module.exports = __webpack_public_path__ + "static/2-f5a106a309aa6f68db52f1624c09073f.jpg";